"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredInternalChatsContext = void 0;
const react_1 = require("react");
exports.FilteredInternalChatsContext = (0, react_1.createContext)({});
